// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----subscribeForm-module---root---1N6AT","text":"src-components----subscribeForm-module---text---WcOSZ","smallText":"src-components----subscribeForm-module---smallText---18QhU","formRow":"src-components----subscribeForm-module---formRow---ufBoL","label":"src-components----subscribeForm-module---label---3UuUd","input":"src-components----subscribeForm-module---input---2ZyaL","hiddenInput":"src-components----subscribeForm-module---hiddenInput---2hMFs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/subscribeForm.module.scss
// module id = 452
// module chunks = 114276838955818